<template>
  <div>
    <div class="immo_carousel_offer_blur" ref="immo_carousel_offer_blur">
      <div class="immo_carousel_offer_blur_content"></div>
    </div>

    <div>
      <div
        :id="'immo_carousel_offer_' + of_id"
        class="carousel slide carouseldetails"
        :class="imageSize === 'small' ? 'carousel-list' : ''"
        data-ride="carousel"
        style="margin:0 auto;"
        :style="imageSize !== 'home' ? 'max-width:1400px;' : ''"
      >
        <div class="carousel-inner">
          <div
            class="carousel-item"
            :class="index === 0 ? ' active' : ''"
            v-for="(image, index) in images"
            :key="index"
            :data-src="
              `${$config.server_url}/api/1.0/images/${image.fi_id}/${imageWidth}/${imageHeight}/${imageType}`
            "
          >
            <div
              :style="
                `background-image: url(${$config.server_url}/api/1.0/images/${image.fi_id}/${imageWidth}/${imageHeight}/${imageType})`
              "
              :class="{
                'carousel-bgimage-medium': imageSize === 'medium',
                'carousel-bgimage': imageSize === 'small',
                'carousel-homeimage': imageSize === 'home'
              }"
              @click="showImage(index)"
            ></div>
            <!-- <img
            @click="showImage(index)"
            class="d-block img-fluid w-100 img"
            :src="
              `${$config.server_url}/api/1.0/images/${image.fi_id}/${imageWidth}/${imageHeight}/${imageType}`
            "
            :alt="image.fi_description"
          /> -->
          </div>
          <!-- <div
            :class="{
              'carousel-heart': true,
              active: $store.state.favories.indexOf(of_id) >= 0
            }"
            v-if="showFavorite"
            @click="addFavorite()"
          >
            <icon
              :name="
                $store.state.favories.indexOf(of_id) >= 0
                  ? 'heart'
                  : 'regular/heart'
              "
              scale="2"
            />
          </div> -->
        </div>
        <a
          class="carousel-control-prev arrow"
          :href="'#immo_carousel_offer_' + of_id"
          role="button"
          data-slide="prev"
          v-if="images.length > 1"
        >
          <span class="carousel-control-prev-icon icon" aria-hidden="true">
            <icon class="chevron" name="chevron-left"></icon>
          </span>
          <span class="sr-only">Previous</span>
        </a>
        <a
          class="carousel-control-next arrow"
          :href="'#immo_carousel_offer_' + of_id"
          role="button"
          data-slide="next"
          v-if="images.length > 1"
        >
          <span class="carousel-control-next-icon icon" aria-hidden="true">
            <icon class="chevron" name="chevron-right"></icon>
          </span>
          <span class="sr-only">Next</span>
        </a>
      </div>
      <immo-carousel-big
        v-model="showBigCarousel"
        :images="images"
        :indexImage="indexImage"
      ></immo-carousel-big>
    </div>
  </div>
</template>

<script>
export default {
  name: "immocarouselimages",
  components: {},
  props: {
    of_id: String,
    images: Array,
    canEnlarge: Boolean,
    imageSize: String,
    showFavorite: Boolean
  },
  data() {
    return {
      indexImage: 0,
      showBigCarousel: false,
      imageWidth: 400,
      imageHeight: 300,
      imageType: "cover"
    };
  },
  computed: {},
  watch: {},
  async mounted() {
    // console.log("of_id", this.of_id);
    if (this.imageSize === "medium") {
      this.imageWidth = 730;
      this.imageHeight = 413;
      this.$$("#immo_carousel_offer_" + this.of_id).on(
        "slide.bs.carousel",
        evt => {
          let el = this.$$(evt.relatedTarget);
          el.parent()
            .parent()
            .parent()
            .parent()
            .find(".immo_carousel_offer_blur_content")
            .css("background-image", `url(${el.attr("data-src")})`);
        }
      );
      //this.imageType = "contain";
    } else if (this.imageSize === "home") {
      this.imageWidth = 2000;
      this.imageHeight = 1000;
      this.$$(this.$refs.immo_carousel_offer_blur).hide();
    } else {
      this.$$(this.$refs.immo_carousel_offer_blur).hide();
    }
  },
  methods: {
    addFavorite() {
      this.$store.dispatch("addFavorite", this.of_id);
    },
    showImage(index) {
      if (this.canEnlarge) {
        this.indexImage = index;
        this.showBigCarousel = true;
      } else {
        this.$emit("clickimg", this.of_id);
      }
    }
  }
};
</script>
<style scoped lang="scss">
.img {
  border-radius: 10px;
  cursor: pointer;
}
.arrow {
  height: 40px;
  width: 40px;
  top: calc(50% - 20px);
  background-color: #fff;
  border-radius: 50%;
}
.carousel-control-prev {
  box-shadow: -2px 3px 5px 1px #7d7d7d;
  left: 20px;
}
.carousel-control-next {
  box-shadow: 1px 3px 5px 1px #7d7d7d;
  right: 20px;
}
.carousel-list .carousel-control-prev,
.carousel-list .carousel-control-next {
  display: none;
}
.carousel-list:hover .carousel-control-prev,
.carousel-list:hover .carousel-control-next {
  display: flex;
}
.carousel-control-prev-icon,
.carousel-control-next-icon {
  line-height: 20px;
}
.chevron {
  color: black;
}
// .carouseldetails {
//   height: 400px;
// }
.carousel-bgimage {
  height: 300px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.carousel-bgimage-medium {
  height: calc(80vh - 350px);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.carousel-homeimage {
  height: 80vh;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
// @media (min-width: 576px) {
//   .carousel-bgimage-medium {
//     height: 300px;
//   }
// }
// @media (min-width: 768px) {
//   .carousel-bgimage-medium {
//     height: 400px;
//   }
// }
@media (min-width: 992px) {
  .carousel-bgimage-medium {
    height: calc(80vh - 200px);
  }
}
// @media (min-width: 1200px) {
//   .carousel-bgimage-medium {
//     height: 600px;
//   }
// }
.immo_carousel_offer_blur {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.immo_carousel_offer_blur_content {
  position: absolute;
  top: -5%;
  left: -5%;
  width: 110%;
  height: 110%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  filter: blur(1.25rem);
}
/* .carousel-heart {
  position: absolute;
  color: white;
  z-index: 10;
  top: 20px;
  right: 20px;
  cursor: pointer;
  color: #7d7d7d;
  &.active {
    color: #d71e29;
  }
} */
</style>
